import { CardPaymentHooks, PaymentObj } from 'paymentIntegrations/types';

import { ApiResponse } from '../types';

import { parseJSONPTerminalResponse, printReceipts } from './utils';

const handleReturnTerminalResponse = (
  response: string,
  cardPayment: PaymentObj,
  { beforeDocSave }: CardPaymentHooks,
) => async (dispatch): Promise<ApiResponse | null> => {
  if (response) {
    const terminalResponse = parseJSONPTerminalResponse(response);

    if (
      terminalResponse.RcmResponse?.RESPONSE?.HOSTRESPONSEDESCRIPTION ===
      'Approval'
    ) {
      const {
        APPROVEDAMOUNT,
        CARDBRAND,
        ACCOUNT,
        TRANSACTIONID,
        RECEIPTTEXT,
      } = terminalResponse.RcmResponse.RESPONSE;

      await beforeDocSave({
        key: cardPayment.key,
        type: 'CARD',
        amount: -Math.abs(Number(APPROVEDAMOUNT)).toFixed(2),
        cardType:
          CARDBRAND.toUpperCase() === 'AMERICAN EXPRESS' ? 'AMEX' : CARDBRAND,
        cardNumber: ACCOUNT.slice(-4),
        attributes: {
          refNo: TRANSACTIONID,
        },
        paid: true,
      });

      dispatch(printReceipts(RECEIPTTEXT));

      return terminalResponse;
    }
  }
  return null;
};

export default handleReturnTerminalResponse;
